import React from 'react'
import { Link } from 'react-router-dom'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import './Post.css'

import moment from 'moment'
import LikePost from '../LikePost/LikePost'

const Post = ({props, id}) => {
  const { postTitle, postText, platform, userName,createdAt, imgURL  } = props
  const { isLight } = React.useContext(ThemeContext)

  return (
    <section className={`post ${isLight ? "" : "dark"}`}>
      <div className="post__container">

        <div className="post__user-details">
          

          <div className="post__col">
            <div className="post__platform">
              <Link to={`/platform/${platform}`}>
                <h2>TP/{platform}</h2>
              </Link>
            </div>
            
            <div className="post__username">
              <Link to={`/user/${userName}`}>
                <h2>By TPu/{userName}</h2>
              </Link>
              <h2 className="post__platform__date-date">{moment(createdAt.toDate()).format("[on] MMM Do YYYY [at] h:mm a") }</h2>
            </div>
            
          </div>
        </div>
      
        <div className="post__post-details">
          <div className="post__post-title">
            <Link to={`/post/${id}`}>
              <h1>{postTitle}</h1>
            </Link>
          </div>
          {imgURL ? (
            <>
              <img src={imgURL} alt="erget" className="post__img"/>
            </>
          ) : (  
            <div className="post__post-para">
              <p>{postText}</p>
            </div>
          )}
        </div>

        <div className="post__actions">
          <LikePost postID={id} />

          <Link to={`/post/${id}`}>
            <h1 className="post__comments__link">View comments</h1>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Post
